// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-messenger__icon {
    margin-top: 0.1rem;
    border-radius: 50%;
    cursor: pointer;
}

.contact-communication__channel-name-select {
    display: block;
}

.contact-communication-column {
    font-weight: 700;
    margin-top: 0.78rem;
    margin-bottom: 0.72rem;
    min-width: 4rem;
    max-width: 8rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

    .contact-communication-column input.form-control {
        padding-bottom: 5px;
        height: auto;
        margin-top: 16px;
    }`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/contact-item-info/contact-communications-list/contact-communication-item/ContactCommunicationItem.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;IAEI;QACI,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;IACpB","sourcesContent":[".contact-messenger__icon {\r\n    margin-top: 0.1rem;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n.contact-communication__channel-name-select {\r\n    display: block;\r\n}\r\n\r\n.contact-communication-column {\r\n    font-weight: 700;\r\n    margin-top: 0.78rem;\r\n    margin-bottom: 0.72rem;\r\n    min-width: 4rem;\r\n    max-width: 8rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n    .contact-communication-column input.form-control {\r\n        padding-bottom: 5px;\r\n        height: auto;\r\n        margin-top: 16px;\r\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
